'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useTagPickerOptionGroup", {
    enumerable: true,
    get: function() {
        return useTagPickerOptionGroup;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactcombobox = require("@fluentui/react-combobox");
const useTagPickerOptionGroup = _reactcombobox.useOptionGroup_unstable;
